//REACT
import React, { createRef, useCallback, useState } from 'react'
//URL
import configData from "../../../config.json";
//OTROS
import axios, { AxiosRequestConfig } from 'axios'
//COMPONENTES DEL PROYECTO
import InputFileUpload from '../Vacaciones/InputFileUploadComponent';
import Cargando from "components/Varios/Cargando";
//BOOTSTrAP
import { Input, Modal, ModalBody, ModalHeader, Container, Col, Row, FormGroup, Label, Button } from 'reactstrap'
//TYPES
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { FileInfo, FileInfoUrl } from '../Vacaciones/ModalFirmarReporteAnual';
import { DatosVistaPrevia } from './AnalistaAdministraSolicitudesCertificados';
import { CertificadoDescarga } from 'components/UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados';

//SERVICES
import { authenticationService } from "services/authentication.service";
//HELPER FUNCTIONS PROYECTO
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
import ModalCargando from 'components/Varios/ModalCargando';

type propsModalFirmaMasiva = {
    show: boolean,
    onClose: () => void,
    toogle: () => void,
    onFirmaCompleata:() => void,
    datos: CertificadoDescarga[],
}

type responseFirmaMasiva = {
    certificadosexitosos:Array<string>,
    certificadosfracasos:Array<string>
}

export const ModalFirmaMasivaCertificados = (props: propsModalFirmaMasiva) => {


    /*****STATES */
    const [loadingFirma, setloadingFirma] = useState<boolean>(false)
    const [fileEnviar, setfileEnviar] = useState<FileInfoUrl>()
    const [contrasenia, setcontrasenia] = useState<string>()
    const [mostrarConfirmacionFirma, setmostrarConfirmacionFirma] = useState<boolean>(false);
    const [contenidoErrores, setcontenidoErrores] = useState<HTMLElement>()
    const [resultadoFirma, setresultadoFirma] = useState<HTMLElement>()
    // REFERENCIAS>
    const ButtonAcept: React.RefObject<HTMLButtonElement> = createRef();

    function ReiniciarValores (firmaCompleta=false){
        setloadingFirma(false)
        setfileEnviar(undefined)
        setcontrasenia("")
        setcontenidoErrores(undefined)
        setresultadoFirma(undefined)
        if( typeof(props.toogle) === "function" && !firmaCompleta){
            props.toogle()
        }
        else if( typeof(props.onFirmaCompleata) === "function" && firmaCompleta){
            props.onFirmaCompleata()
        }
    }
    function handleFileUploadChange(archivo: FileInfo) {
        var uploadFile = new File([archivo.file], archivo.id + ".pdf");

        const src = window.URL.createObjectURL(uploadFile);

        const firmaArchivoInfo: FileInfoUrl = {
            nombreFile: archivo.nombreFile,
            file: uploadFile,
            id: archivo.id,
            url: src
        };

        setfileEnviar(firmaArchivoInfo)
    }

    function handleChangeContra(e: string) {
        var _contrasenia_ = new TextEncoder().encode(e).toString();

        setcontrasenia(_contrasenia_)
    }

    const FirmarDocumentos = async (informacionFirmar: CertificadoDescarga[]) => {
        var currentUser: UserData = authenticationService.currentUserValue;
        const formData = new FormData();
        if (fileEnviar && contrasenia) {
            formData.append("files", fileEnviar.file, fileEnviar.file.name);
            formData.append("contrasenia", contrasenia)

        }
        if (informacionFirmar.length > 0) {
            informacionFirmar.forEach(element => {
                formData.append("certificados[]", element.idcertificado ? element.idcertificado.toString() : "0")
            });
        }

        let instance = axios.create({ baseURL: configData.SERVER_URL });
        let options: AxiosRequestConfig = {
            url: `GenerarCertificados/Director/FirmaMasivaCertificados`,
            data: formData,
            method: "POST",
            headers: {
                Authorization: `KEYESPOL ${currentUser?.token}`
            }
        }
        setloadingFirma(true)
        try {
            await instance.request<any>(options).then((response) => {
                var resultado:responseFirmaMasiva = response.data;
                const buttonContinuar:any = (
                    <Button onClick = {()=> ReiniciarValores(true)} className="text-center">
                        Continuar y actualizar tabla
                    </Button>
                )
                var resultadoFirma:any = undefined;
                if(resultado.certificadosexitosos.length > 0 && resultado.certificadosfracasos.length === 0){
                    resultadoFirma = (
                        <div>
                            Todos los certificados fueron firmados con éxito
                            {buttonContinuar}
                        </div>
                    )
                }
                else if(resultado.certificadosfracasos.length > 0){
                    resultadoFirma = (
                        <div className="mt-3">
                            <div className='text-center  mini-title-firmamasiva'>La Firma de documentos ha concluido</div>
                            {resultado.certificadosfracasos.map((texto,indifracaso) => {
                                return ( 
                                    <p key={"certiFracaso " + indifracaso} className ="mb-0">
                                        {texto}
                                    </p>
                                )
                            })}
                            {resultado.certificadosexitosos.length > 0 &&
                            (<p>
                                El resto de certificados se han firmado con éxito
                            </p>)
                            
                            }
                            {
                                buttonContinuar
                            }
                        </div>
                    )
                }
                setresultadoFirma(resultadoFirma)

            });
        } catch (error) {
            var error_any: any = error
            var status_number = handle_error(error_any);

            var listado_errores: Array<string> = []
            switch (status_number) {
                case 0 || -1:
                    listado_errores.push("No se ha podido establecer conexión con el servidor")
                    break;
                case 409:
                    listado_errores.push(error_any.response.data)
                    break;
                case 500:
                    listado_errores.push("Ha ocurrido un evento inesperado. Intente más tarde")
                    break;
                default:
                    break;
            }
            if (listado_errores.length > 0) {
                var contenido: any = (
                    <div>
                        Ha(n) ocurrido el/los siguiente(s) inconveniente(s):
                        {
                            listado_errores.map((textoerror, index) => {
                                return (
                                    <p
                                        key={"error_modal_firmamasiva_cert" + index}
                                    >
                                        {index+1 + ".- " + textoerror}
                                    </p>
                                )
                            })
                        }
                    </div>
                )
                setcontenidoErrores(contenido);
            }
        }
        setloadingFirma(false)

    }

    function CerrarModal(){
        
        
        props.onClose()
        document.body.classList.remove('modal-open')
    }


    if (loadingFirma) {
        return (
            <ModalCargando
                show={loadingFirma}
                onClose={() => setloadingFirma(false)}
                size={"sm"}
                textoCargando={"Firmando Certificados, espere un momento por favor..."}
            />
        )
    }
    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"xl "}
            fullscreen={"xl"}
            centered={true}
            onClosed={() => CerrarModal()}
            contentClassName="custom-modal-style"
        >
            <ModalHeader close={<button onClick={() => props.toogle()} >x</button>}>
                Firma Masiva de Certificados
            </ModalHeader>
            <ModalBody >
                {
                    props.datos.length > 0 &&
                    (
                        <React.Fragment>
                            <div>
                                Se firmarán los siguientes certificados:
                            </div>
                            {
                                props.datos.map((datosDescarga, indicedatos) => {
                                    return (
                                        <div key={datosDescarga.idcertificado}>
                                            {indicedatos + 1 + ".- " + datosDescarga.nombreTipoCertificado + " solicitado por " + datosDescarga.nombreSolicita}
                                            <br />
                                        </div>
                                    )
                                })
                            }
                        </React.Fragment>
                    )
                }
                <Container>
                    <Row form className="mt-3">
                        <Col md={6}>
                            <FormGroup>
                                <Label for="nombremencion">Certificado*</Label>
                                <InputFileUpload
                                    icon="upload"
                                    onChange={(archivo: FileInfo) => handleFileUploadChange(archivo)}
                                    name="DOC"
                                    id="CERT"
                                    placeholder="Subir firma electrónica"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="nombremencion">Contraseña*</Label>
                                <Input
                                    type="password"
                                    name="contrasenia"
                                    id="contrasenia"
                                    placeholder=""
                                    onChange={(e) => handleChangeContra(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Container>



                

                <button id="botonCancelar" className="btn btn-secondary" onClick={() => ReiniciarValores()}>
                    Cancelar
                </button>
                <Button
                    color="primary"
                    id="botonAceptar"
                    onClick={() => FirmarDocumentos(props.datos)}
                    ref={ButtonAcept} >Firmar Certificado
                </Button>
                <br/>
                <Row>
                    <Col>
                        <div id="errores_firmamasivaCertificados" className="errores_firmar">
                            {contenidoErrores}
                        </div>
                    </Col>
                </Row>
                {
                    <React.Fragment>
                        <br/>
                        <Row className="justify-content-center mt-5">
                            <Col sm={12} md={12} xl={10} >
                                {resultadoFirma}
                            </Col>
                        </Row>
                    </React.Fragment>
                }

            </ModalBody>

        </Modal>)


}

